import React, { useState } from 'react'
import ArrowIcon from './icons/ArrowIcon'
import clsx from 'clsx'

interface AccordionItemProps {
  title: string
  children: React.ReactNode
  onClick?: (title: string) => void
}

interface AccordionProps {
  items: {
    title: string
    content: React.ReactNode
  }[]
  itemOnClick?: (title: string) => void
}

const AccordionItem: React.FC<AccordionItemProps> = ({
  title,
  children,
  onClick,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleDropdown = () => {
    setIsOpen(!isOpen)
    onClick?.(title)
  }

  return (
    <div className="border-b border-neutral-20-borders-dividers overflow-hidden">
      <button
        onClick={toggleDropdown}
        aria-expanded={isOpen}
        aria-controls={`accordion-content`}
        className="w-full py-5 gap-x-2 flex text-start title-md text-neutral-60-primary-text items-center justify-between focus:outline-hidden"
      >
        {title}
        <span
          className={clsx('transition-transform duration-300', {
            'rotate-180': isOpen,
          })}
        >
          <ArrowIcon size={[10, 10]} fill="fill-neutral-60-primary-text" />
        </span>
      </button>
      <div
        className={clsx(
          'overflow-hidden transition-max-height duration-300 ease-in-out',
          { 'max-h-screen': isOpen, 'max-h-0': !isOpen },
        )}
      >
        <div>{children}</div>
      </div>
    </div>
  )
}

const Accordion: React.FC<AccordionProps> = ({ items, itemOnClick }) => {
  return (
    <div className="overflow-hidden">
      {items.map((item, index) => (
        <AccordionItem key={index} title={item.title} onClick={itemOnClick}>
          {item.content}
        </AccordionItem>
      ))}
    </div>
  )
}

export default Accordion
